import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {PathService} from "./path.service";
import {OkInfo} from "../util/interfaces";
import {map, tap} from "rxjs/operators";

export type KitStatus = 'registered'|'scheduled'|'assigned_to_lab'|'en_route_to_lab'|'at_lab'|'tested'|'notified'|'test_not_performed';

export interface KitChange {
    newStatus: KitStatus;
    sendEmail: boolean;
}

export interface Kit {
    id: number;
    order_id: number;
    order_number: number;
    email: string;
    code: string;
    status: KitStatus;
    created: string;
    updated: string;
}

export interface KitBundle {
    total: number;
    results: Kit[];
}

@Injectable({
    providedIn: 'root'
})
export class KitService {

    private readonly kitRoot;

    constructor(private http: HttpClient,
                private pathService: PathService) {
        this.kitRoot = `${this.pathService.apiRoot}/kit`;
    }

    getAll(offset: number, max: number): Observable<KitBundle> {
        return this.http.get<KitBundle>(`${this.kitRoot}/${offset}/${max}`);
    }

    update(kit: Kit, change: KitChange): Observable<boolean> {
        return this.http.put<OkInfo>(this.kitRoot, {
            id: kit.id,
            status: change.newStatus,
            sendEmail: change.sendEmail
        }).pipe(
            tap(() => { kit.status = change.newStatus }),
            map((info) => true)
        );
    }
}
